import { store } from '@/store'

export default {
  comments_post_comments(data, vue) {
    if (vue && vue.$root && data && data.data && data.data.entity_id && data.data.entity) vue.$root.$emit('post-comment', data.data);
  },
}


// WEBPACK FOOTER //
// ./src/modules/logs/pusher.js